<template>
  <div>
    profile
  </div>
</template>

<script>
export default {
  name: 'AccountSettingsProfile',
};
</script>
